export const INITIAL = {
	TAB: 0,
	VALUES: {
		name: '',
		description: '',
		race: '',
		caste: '',
		tendency: '',
		life: 0,
		coins: 0,
		actions: 0,
		strength: 0,
		dexterity: 0,
		constitution: 0,
		intelligence: 0,
		wisdom: 0,
		charisma: 0,
		capacity: {
			life: 0,
			physical: 0,
			mental: 0,
		},
		modified: {
			strength: 0,
			dexterity: 0,
			constitution: 0,
			intelligence: 0,
			wisdom: 0,
			charisma: 0,
		}
	},
}